'use client'

import { useState, useTransition } from 'react'
import { LockKeyhole, ArrowRight } from 'lucide-react'
import { unlockProjects } from '../actions'

export default function ProjectPasswordGate({ redirectTo }: { redirectTo: string }) {
  const [error, setError] = useState<string | null>(null)
  const [isPending, startTransition] = useTransition()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    startTransition(async () => {
      // On success the action redirects (so this call never returns); we only
      // reach the next line when the password was rejected.
      const result = await unlockProjects({ error: null }, formData)
      setError(result?.error ?? null)
    })
  }

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-8 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full border border-[var(--text-secondary)]/40">
        <LockKeyhole size={24} strokeWidth={1.5} className="text-[var(--text-secondary)]" />
      </div>

      <form onSubmit={handleSubmit} className="w-full max-w-sm">
        <input type="hidden" name="redirectTo" value={redirectTo} />
        <div className="flex items-center gap-2 rounded-[4px] border border-[var(--text-secondary)]/20 bg-[var(--bg-primary)] px-4 py-3 focus-within:border-[var(--text-secondary)]/50 transition-colors">
          <input
            type="password"
            name="password"
            placeholder="Password"
            autoFocus
            autoComplete="current-password"
            enterKeyHint="go"
            aria-label="Password"
            disabled={isPending}
            // text-base (16px) prevents iOS Safari from auto-zooming on focus,
            // which otherwise causes a horizontal scroll on mobile.
            className="min-w-0 flex-1 bg-transparent text-base text-[var(--text-primary)] placeholder:text-[var(--text-secondary)] focus:outline-none"
          />
          <button
            type="submit"
            disabled={isPending}
            aria-label="Submit password"
            className="shrink-0 text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors disabled:opacity-50"
          >
            <ArrowRight size={18} strokeWidth={1.5} />
          </button>
        </div>
        {error && <p className="mt-3 text-sm text-[var(--text-secondary)]">{error}</p>}
      </form>
    </div>
  )
}
